import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { faCircleInfo, faLocationDot, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RedeCredenciadaPdfComponent } from 'src/app/shared/pdf/rede-credenciada-pdf/rede-credenciada-pdf.component';
import { ConvenantService } from 'src/app/shared/services/convenant.service';
@Component({
  selector: 'app-rede-credenciada',
  templateUrl: './rede-credenciada.component.html',
  styleUrls: ['./rede-credenciada.component.css']
})
export class RedeCredenciadaComponent implements OnInit {
  formData: FormGroup = new FormGroup({
    stateId: new FormControl(),
    cityId: new FormControl(),
    companyTypeId: new FormControl(),
    professionalCouncil: new FormControl(),
    medicalExpertiseId: new FormControl(),
    name: new FormControl(),
    companyName: new FormControl(),
    page: new FormControl(),
    limit: new FormControl(10),
    neighborhood: new FormControl(),
    registroANS: new FormControl(),
  });
  //Variaveis
  abaSelecionada: string = 'credenciados';
  loadingCosts: boolean = false;
  loadingPrint: boolean = false;
  pesquisa: boolean = false;
  pesquisaRealizada: any;
  quantidadeDescredenciados: number = 0;
  //Icones
  faTriangleExclamation = faTriangleExclamation;
  faCircleInfo = faCircleInfo;
  faLocationDot = faLocationDot;
  //Resposividade
  isMobile: any = true;
  isTablet: any = true;
  isDesktopDevice: any = true;
  //Imagens
  caminhoImagem: string = '../../../../../assets/img/rede-credenciada/';
  //Variaveis para a paginação
  paginaAtual = 1;
  tamanhoPaginaMedico!: number;
  tamanhoPaginaMensalidade!: number;
  itemsPerPage = 5;
  numeroPagina: any = null;
  //Listas
  lista: any = [];
  listaReferenciados: any = [];
  listaDescredenciados: any = [];
  listaNovosCredenciados: any = [];
  listEntidadeEspecialidade: any = [];
  listaCredenciados: any = [];
  listaRedeCredenciada: any = [];
  listCities: any;
  listSpecialties: any;
  listTypeEstablishment: any;
  listNeighborhood: any;
  listPlans: any;
  visibleIndexes: number[] = [];
  constructor(private formBuilder: FormBuilder, private datePipe: DatePipe, private modalService: NgbModal,
    private convenantService: ConvenantService, private deviceService: DeviceDetectorService, private elRef: ElementRef) {
    this.initForm();
  }
  cityChanged() {
    if (this.formData.get('cityId')?.value != null) {
      this.listCities.map(
        (x: any) => {
          if (x.id === this.formData.get('cityId')?.value) {
            this.listNeighborhood = x.neighborhood;
            //this.formData.get('neighborhood').enable();
          }
        }
      )
    }
  }
  pesquisar() {
    this.loadingCosts = !this.loadingCosts;
    this.formData.get('page')?.setValue(this.numeroPagina == null ? 1 : this.numeroPagina);
    this.convenantService.getSearchConvenant(this.formData.value).subscribe({
      next: (res: any) => {
        this.listaRedeCredenciada = res;
        this.pesquisa = true;
        this.loadingCosts = !this.loadingCosts;
        this.quantidadeDescredenciados = res.descredenciados.ultimoMes.totalFiltered + res.descredenciados.ultimoSemestre.totalFiltered;
        this.verificaRetornoVazios();
      }
    });
  }
  verificaRetornoVazios() {
    if (this.listaRedeCredenciada != null && this.listaRedeCredenciada.credenciados.totalFiltered == 0 &&
      this.listaRedeCredenciada.referenciados.totalFiltered == 0 &&
      this.listaRedeCredenciada.novosCredenciados.totalFiltered == 0 &&
      this.listaRedeCredenciada.descredenciados.ultimoMes.totalFiltered == 0 &&
      this.listaRedeCredenciada.descredenciados.ultimoSemestre.totalFiltered == 0
    ) {
      this.pesquisaRealizada = false;
    } else {
      this.pesquisaRealizada = true;
    }
  }
  initForm() {
    //this.formData.get('neighborhood').disable();       
    this.convenantService.getCompanyType().subscribe({
      next: (res: any) =>
        this.listTypeEstablishment = res
    });
    this.convenantService.getListCities().subscribe({
      next: (res: any) =>
        this.listCities = res
    });
    this.convenantService.getListPlans().subscribe({
      next: (res: any) =>
        this.listPlans = res
    });
    this.convenantService.getListMedicalExpertise().subscribe({
      next: (res: any) =>
        this.listSpecialties = res
    });
  }
  printPdf() {
    this.convenantService.getSearchConvenant({ ...this.formData.value, page: 1, limit: 50 }).subscribe({
      next: (res: any) => {
        this.listaRedeCredenciada = res;
        this.pesquisa = true;
        this.quantidadeDescredenciados = res.descredenciados.ultimoMes.totalFiltered + res.descredenciados.ultimoSemestre.totalFiltered;
        this.verificaRetornoVazios();
        const modalRef = this.modalService.open(RedeCredenciadaPdfComponent, { windowClass: 'custom-modal-size-imprimir', size: 'lg', centered: true });
        modalRef.componentInstance.listaRedeCredenciada = this.listaRedeCredenciada;
        modalRef.componentInstance.formulario = this.formData.value;
      }
    });
  }
  onChangePagination(page: number) {
    const targetSection = this.elRef.nativeElement.querySelector('#content-rede-credenciada');
    this.formData.get('page')?.setValue(page);
    this.convenantService.getSearchConvenant(this.formData.value).subscribe({
      next: (res: any) => {
        this.listaRedeCredenciada = res;
        this.pesquisa = true;
        this.loadingCosts = !this.loadingCosts;
        this.quantidadeDescredenciados = res.descredenciados.ultimoMes.totalFiltered + res.descredenciados.ultimoSemestre.totalFiltered;
        this.verificaRetornoVazios();
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }
  isVisible(index: number) {
    return this.visibleIndexes.indexOf(index) !== -1;
  }
  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
    if (this.listaRedeCredenciada && this.listaRedeCredenciada.credenciados) {
      this.listaRedeCredenciada.credenciados.forEach((a: any, index: any) => {
        setTimeout(() => {
          this.visibleIndexes.push(index);
        }, index * 450);
      });
    }
  }
}
